/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/OutboundConnectorDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const OutboundConnectorDetailTestIds = {
  btnDelete: "btn-delete",
  btnTestConnection: "btn-test-connection",
  btnToggleEnabled: "btn-toggle-enabled",
  btnUnsavedLeave: "btn-unsaved-leave",
  btnUnsavedStay: "btn-unsaved-stay",
  deleteConfirmDialog: "delete-confirm-dialog",
  outboundConnectorDetailPage: "outbound-connector-detail-page",
  tabAttributes: "tab-attributes",
  tabConfig: "tab-config",
  tabOverview: "tab-overview",
  tabProvisioningTasks: "tab-provisioning-tasks",
  testResultDialog: "test-result-dialog"
} as const;
